import styled from "styled-components";
import Text from "@streeteasy/design-system/deprecated/Text";

export const AdvertisementDisclosure = styled(Text).attrs({
  type: "sm"
})`
  margin-top: 20px;
  margin-bottom: -8px;
  line-height: 22px;
`;
